import React from 'react'
import { ApolloProvider } from '@apollo/client';
import Route from 'routes/routes'
import client from '../server/apollo';
const Web = () => {
  return (
    <ApolloProvider client={client}>
      <Route />
    </ApolloProvider>
  )
}

export default Web